<template>
  <div class="mb-5">
    <div class="mt-5 row">
      <div class="mx-auto col-lg-9 col-xs-12">
        <b-breadcrumb :items="items"></b-breadcrumb>
        <b-card class="mb-3">
          <div class="alert alert-danger" v-if="error">{{ error }}</div>
          <div class="alert alert-success" v-if="sucesso">
            {{ sucesso }}
          </div>
          <b-row class="mb-3">
            <b-col cols="md-4 12">
              <b-form-group
                label="Tipo de Cesta"
                invalid-feedback="Obrigatório informar o tipo de cesta."
              >
                <b-form-select
                  :options="optTipoCesta"
                  v-model="$v.tipo_cesta.$model"
                  :class="
                    `form-select` + ($v.tipo_cesta.$error ? ` is-invalid` : ``)
                  "
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="md-4 12">
              <b-form-group
                label="Data de Retirada"
                invalid-feedback="Obrigatório informar data de retirada."
              >
                <b-form-input
                  v-model="$v.data_retirada.$model"
                  type="date"
                  :max="'9999-12-31'"
                  :class="
                    `form-control` +
                    ($v.data_retirada.$error ? ` is-invalid` : ``)
                  "
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3" align="right">
            <b-col>
              <b-button variant="outline-secondary" @click="limpar()">
                <font-awesome-icon :icon="['fa', 'eraser']" /> Limpar
              </b-button>
              <a>&nbsp;</a>
              <b-button variant="primary" @click="pesquisar()"
                ><font-awesome-icon :icon="['fas', 'search']" />
                Pesquisar</b-button
              >
            </b-col>
          </b-row>
        </b-card>
        <div class="card">
          <div class="card-body">
            <b-card no-body>
              <b-card-header size="sm">
                <div align="right">
                  <b-button
                    @click="atualizar()"
                    variant="success"
                    title="Atualizar Vouchers"
                    :disabled="tabela.items.length == 0"
                  >
                    <font-awesome-icon :icon="['fa', 'refresh']" class="mr-1" />
                    Atualizar Beneficiários
                  </b-button>
                </div>
              </b-card-header>
              <b-table
                no-provider-paging
                small
                responsive
                :empty-text="tabela.emptyText"
                :fields="tabela.fields"
                :items="tabela.items"
                :show-empty="tabela.showEmpty"
                :striped="tabela.striped"
                :current-page="tabela.currentPage"
                :per-page="tabela.perPage"
                bordered
              >
                <template v-slot:cell(data)="data">
                  {{ formataData(data.item.data) }}
                </template>
                <template v-slot:cell(dataRetirada)="data">
                  {{ formataData(data.item.dataRetirada) }}
                </template>
                <template v-slot:cell(tipoProduto)="data">
                  {{ descricaoTipoCesta(data.item.tipoProduto) }}
                </template>
                <template v-slot:cell(produtoRetirado)="data">
                  {{ descricaoTipoCesta(data.item.produtoRetirado) }}
                </template>
              </b-table>
              <b-card-footer size="sm">
                <b-row>
                  <b-col>
                    <b-input-group
                      class="quantidade-registros"
                      prepend="Quantidade de registros"
                    >
                      <b-input
                        disabled
                        class="quantidade-registros"
                        v-model="tabela.totalRows"
                      >
                        {{ tabela.totalRows }}
                      </b-input>
                    </b-input-group>
                  </b-col>
                  <b-col>
                    <b-pagination
                      align="right"
                      :total-rows="tabela.totalRows"
                      v-model="tabela.currentPage"
                      :per-page="tabela.perPage"
                    >
                    </b-pagination>
                  </b-col>
                </b-row>
              </b-card-footer>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import helpers from "../helpers";
export default {
  components: {},
  data() {
    return {
      items: [
        { text: "Admin" },
        { text: "Gerenciar Vouchers Retirados", active: true },
      ],
      optionsTipoRelatorio: [
        { text: "Pdf", value: this.$store.getters.const.relatorio.TIPO.PDF },
        {
          text: "Excel",
          value: this.$store.getters.const.relatorio.TIPO.EXCEL,
        },
      ],
      data_retirada: null,
      tipo_cesta: null,
      optTipoCesta: [],
      error: null,
      sucesso: null,
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "cpfResp",
            label: "CPF",
            class: "text-center",
            thStyle: "width:50px",
          },
          {
            key: "nomeResp",
            label: "Nome",
            class: "text-center",
          },
          {
            key: "numVoucher",
            label: "Voucher",
            class: "text-center",
          },
          {
            key: "data",
            label: "Data Voucher",
            class: "text-center",
          },
          {
            key: "cnpjLoja",
            label: "CNPJ Loja Solicitada",
            class: "text-center",
          },
          {
            key: "tipoProduto",
            label: "Tipo Cesta Solicitada",
            class: "text-center",
          },
          {
            key: "dataRetirada",
            label: "Data Retirada",
            class: "text-center",
          },
          {
            key: "cnpjLojaRetirada",
            label: "CNPJ Loja Retirada",
            class: "text-center",
          },
          {
            key: "produtoRetirado",
            label: "Tipo Cesta Retirada",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: false,
        perPage: 10,
        totalRows: 0,
      },
    };
  },

  computed: {
    http() {
      return this.$store.getters.http;
    },
  },

  validations: {
    data_retirada: {
      required,
    },
    tipo_cesta: {
      required,
    },
  },

  methods: {
    formataData(data) {
      return helpers.formatDateHourToDate(data);
    },

    descricaoTipoCesta(tipo) {
      return helpers.getDescricaoTipoCesta(tipo);
    },

    limpar() {
      this.data_retirada = null;
      this.tipo_cesta = null;
      this.tabela.items = [];
    },

    async pesquisar() {
      this.error = null;
      this.sucesso = null;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.commit("setLoading", true);
        this.http
          .get(`/admin/retorno-vouchers`, {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
            params: {
              data_retirada: this.data_retirada,
              tipo_cesta: this.tipo_cesta,
            },
          })
          .then((response) => {
            if (response.status == 200) {
              this.tabela.items = response.data.dados.dados;
              this.tabela.totalRows = response.data.dados.dados.length;
              this.$store.commit("setLoading", false);
            } else {
              this.$store.commit("setLoading", false);
            }
          })
          .catch((error) => {
            this.error = this.$store.commit("setLoading", false);
            let erro429 = error.response.data.error.message.search("429");
            if (erro429 > 0) {
              this.error =
                "Somente é permitido uma requisição a cada 60 segundos para a API do Supermercados BH. " +
                "Aguarde mais alguns instantes para tentar novamente.";
            } else {
              this.error = error.response.data.error.message;
            }
          });
      }
    },

    verificaPeriodo(mes) {
      this.optTipoCesta = [];
      if (mes == "1") {
        this.optTipoCesta.push(
          { value: 1, text: "1 - Cesta Pequena (Janeiro)" },
          { value: 2, text: "2 - Cesta Grande (Janeiro)" }
        );
      } else {
        this.optTipoCesta.push(
          { value: 3, text: "3 - Cesta Pequena (Julho)" },
          { value: 4, text: "4 - Cesta Grande (Julho)" }
        );
      }
    },

    async buscarParams() {
      try {
        this.http
          .get(`/admin/params`, {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          })
          .then((response) => {
            if (response.data.erro == "false") {
              this.verificaPeriodo(response.data.dados.mes);
            } else {
              this.error = response.data.message;
            }
          });
      } catch (error) {
        this.error = error;
      }
    },

    atualizar() {
      this.error = null;
      this.sucesso = null;
      try {
        this.$store.commit("setLoading", true);
        let params = {
          items: this.tabela.items,
        };
        this.http
          .post(`/admin/atualizar-retorno-vouchers`, params, {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          })
          .then((response) => {
            if (response.data.status == 200) {
              this.$store.commit("setLoading", false);
              this.sucesso = response.data.dados.message;
              this.tabela.items = [];
              this.tabela.totalRows = 0;
            } else {
              this.error = response.data.dados.message;
              this.$store.commit("setLoading", false);
            }
          });
      } catch (error) {
        this.$store.commit("setLoading", false);
        this.error = error;
      }
    },
  },
  mounted() {
    this.buscarParams();
  },
};
</script>

